import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';
import Bizmachine from '@gef-ui/material-icons/Bizmachine';
import Bullhorn from '@gef-ui/material-icons/Bullhorn';
import CakeCandles from '@gef-ui/material-icons/CakeCandles';
import Calendar from '@gef-ui/material-icons/Calendar';
import Handshake from '@gef-ui/material-icons/Handshake';
import HandsHoldingHeart from '@gef-ui/material-icons/HandsHoldingHeart';
import Heart from '@gef-ui/material-icons/Heart';
import LightbulbOn from '@gef-ui/material-icons/LightbulbOn';
import PersonRegular from '@gef-ui/material-icons/PersonRegular';
import UserGroupRegular from '@gef-ui/material-icons/UserGroupRegular';

import { getLeadsOutOfMarketPlace } from 'features/views/dashboard/statistics/selectors';

export const LeadsOutOfMarketPlace = () => {
	const leadsOutOfMarketPlace = useSelector(getLeadsOutOfMarketPlace);

	const iconSx = { color: 'primary.main' };

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container>
					<Grid
						sx={{
							alignItems: 'center',
						}}
						size={2}
					>
						<Typography variant="body1">{getMessage('dashboard:statistics.leads')}</Typography>
					</Grid>
					<Grid size={10}>
						<Stack
							direction="row"
							sx={{
								justifyContent: 'space-around',
							}}
						>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.leadFromWeb')}>
									<Box>
										<Bullhorn sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountLeadFromWeb}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.businessOpportunity')}>
									<Box>
										<LightbulbOn sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountBusinessOpportunity}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.life')}>
									<Box>
										<Heart sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountLife}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.portfolioOpportunity')}>
									<Box>
										<UserGroupRegular sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountPortfolioOpportunity}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.acquisitionsContacts')}>
									<Box>
										<PersonRegular sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountAcquisitionsContacts}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.businessOpportunitySME')}>
									<Box>
										<Bizmachine sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountSME}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.birthday')}>
									<Box>
										<CakeCandles sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountBirthday}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.clientAnniversary')}>
									<Box>
										<Handshake sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountClientAnniversary}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.lifePolicyAnniversary')}>
									<Box>
										<HandsHoldingHeart sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountLifePolicyAnniversary}
								</Typography>
							</Stack>
							<Stack direction="row" spacing={0.5}>
								<Tooltip title={getMessage('dashboard:statistics.leadTypes.nameday')}>
									<Box>
										<Calendar sx={iconSx} />
									</Box>
								</Tooltip>
								<Typography data-testid="leadTypeCount" variant="body1">
									{leadsOutOfMarketPlace?.leadCountNameDay}
								</Typography>
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default LeadsOutOfMarketPlace;
